import { FlaggedSummaryRecord } from '@modules/feedback/store/types';
import { getAudioKeywordSummaryHash } from '@modules/feedback/utils/getAudioKeywordSummaryHash';
import { SummaryFlag, SummaryMessageUnit } from 'generated/graphql';
import { Feedback } from 'v2/core/entities/feedback';
import { UUID } from 'v2/core/entities/uuid';

interface GetAudioSummaryFlagDataOptions {
  feedback: Feedback;
  labelID?: UUID;
  summary: SummaryMessageUnit;
  flaggedSummaryRecords: FlaggedSummaryRecord[];
}

export const getAudioSummaryFlagData = ({
  feedback,
  labelID,
  summary,
  flaggedSummaryRecords,
}: GetAudioSummaryFlagDataOptions) => {
  const keywordSummaryHash = getAudioKeywordSummaryHash(feedback, labelID);

  const msgIdx =
    summary.metadata?.location?.[0].__typename === 'IndexTypeConversation'
      ? summary.metadata?.location?.[0].messageIndex
      : 0;

  const uniqueKeywordSummaryHash = `${keywordSummaryHash}-${msgIdx}`;

  const initialFlag = summary.metadata?.flag;

  const flaggedRecord = flaggedSummaryRecords.find(
    (record) =>
      record.id === feedback.id &&
      record.keywordSummaryHash === uniqueKeywordSummaryHash,
  );
  const isSummaryFlagged = flaggedRecord
    ? flaggedRecord.summaryFlagType === SummaryFlag.Incorrect
    : initialFlag === SummaryFlag.Incorrect;

  return {
    msgIdx,
    keywordSummaryHash,
    uniqueKeywordSummaryHash,
    initialFlag,
    isSummaryFlagged,
  };
};
